module.exports = __webpack_public_path__ + "static/media/SALA-CLINICA-1.bef2b224.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clinica/SALA-CLINICA-1.png
// module id = 160
// module chunks = 0